module.exports = __webpack_public_path__ + "static/media/logo.4dcf94bf.png";